import { render } from "./MailView.vue?vue&type=template&id=280e2636"
import script from "./MailView.vue?vue&type=script&lang=js"
export * from "./MailView.vue?vue&type=script&lang=js"

import "./MailView.vue?vue&type=style&index=0&id=280e2636&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__